'use client';

import React, { useContext } from 'react';
import { ButtonGroup } from './elements';
import { TemplateContext } from '../TemplateContext';
import { useMediaQuery } from '../../../util';
import { Size } from '../../../abstracts';
export const FlexTemplateButtonGroup = ({
  children,
  ...props
}) => {
  const context = useContext(TemplateContext);
  const isMobile = useMediaQuery(`(max-width: ${Size.MD - 1}px)`);
  return /*#__PURE__*/React.createElement(ButtonGroup, props, !isMobile && context.progressStepper, children);
};